import React, { useState } from "react";
import NeoModal from "../../../../components/Common/NeoModal";
import NeoButton from "../../../../components/Common/NeoButton";
import { TRANSFER_REASONS } from "../constants";

const PlatformTransferModal = ({ isOpen, toggle, client, clients = [], teamUsers = [], onConfirm }) => {
    const [newCsmUid, setNewCsmUid] = useState("");
    const [reason, setReason] = useState("reassignment");
    const [saving, setSaving] = useState(false);

    const activeClients = clients.length > 0 ? clients : (client ? [client] : []);

    const csUsers = teamUsers.filter(u =>
        u.platformRole === "cs" || u.platformRole === "comercial" || u.platformRole === "admin" || u.platformRole === "owner"
    );

    const handleConfirm = async () => {
        if (!newCsmUid || activeClients.length === 0) return;
        const selected = csUsers.find(u => u.uid === newCsmUid || u.id === newCsmUid);
        if (!selected) return;
        setSaving(true);
        try {
            const tenantIds = activeClients.map(c => c.id);
            await onConfirm({
                idTenants: tenantIds,
                newCsmUid: selected.uid || selected.id,
                newCsmName: selected.fullName || selected.name || "",
                reason,
            });
        } finally {
            setSaving(false);
            setNewCsmUid("");
            setReason("reassignment");
        }
    };

    const selectedUser = csUsers.find(u => (u.uid || u.id) === newCsmUid);

    const modalTitle = activeClients.length > 1 ? "Transferir Responsabilidade (Lote)" : "Transferir Responsabilidade";
    const modalSubtitle = activeClients.length > 1 
        ? `${activeClients.length} academias selecionadas para alteração de CSM`
        : (client ? `Academia: ${client.name}` : "");

    return (
        <NeoModal
            isOpen={isOpen}
            toggle={toggle}
            title={modalTitle}
            subtitle={modalSubtitle}
            headerIcon="mdi-swap-horizontal"
            size="sm"
            footerActions={
                <div className="d-flex gap-2 justify-content-end w-100">
                    <NeoButton variant="soft-secondary" onClick={toggle} disabled={saving}>
                        Cancelar
                    </NeoButton>
                    <NeoButton
                        variant="primary"
                        onClick={handleConfirm}
                        disabled={!newCsmUid || saving}
                        loading={saving}
                    >
                        Confirmar Transferência
                    </NeoButton>
                </div>
            }
        >
            <div className="d-flex flex-column gap-3">
                {/* Visualização de Clientes Afetados */}
                {activeClients.length > 1 ? (
                    <div className="csm-info-block">
                        <small className="csm-label-caps d-block mb-1">Academias Selecionadas</small>
                        <div className="text-truncate font-size-12 fw-bold text-dark">
                            {activeClients.map(c => c.name).join(", ")}
                        </div>
                    </div>
                ) : (
                    client?.csmName && (
                        <div className="csm-info-block">
                            <small className="csm-label-caps d-block mb-1">CS Atual</small>
                            <span className="fw-bold font-size-13 text-dark">{client.csmName}</span>
                        </div>
                    )
                )}

                {/* Novo CS */}
                <div>
                    <label className="form-label csm-label-caps mb-1">
                        Novo CS Responsável <span className="text-danger">*</span>
                    </label>
                    <select
                        className="form-select form-select-sm csm-select-input"
                        value={newCsmUid}
                        onChange={e => setNewCsmUid(e.target.value)}
                    >
                        <option value="">Selecione um colaborador...</option>
                        {csUsers.map(u => {
                            const uid = u.uid || u.id;
                            // Se estiver transferindo um único cliente, esconde o CSM atual dele
                            if (activeClients.length === 1 && uid === client?.csmId) return null;
                            return (
                                <option key={uid} value={uid}>
                                    {u.fullName || u.name} ({u.platformRole})
                                </option>
                            );
                        })}
                    </select>
                    {selectedUser && (
                        <small className="text-muted csm-text-sm mt-1 d-block">
                            <i className="mdi mdi-check-circle text-success me-1" />
                            {selectedUser.fullName || selectedUser.name} será o novo CS.
                        </small>
                    )}
                </div>

                {/* Motivo */}
                <div>
                    <label className="form-label csm-label-caps mb-1">
                        Motivo da Transferência
                    </label>
                    <select
                        className="form-select form-select-sm csm-select-input"
                        value={reason}
                        onChange={e => setReason(e.target.value)}
                    >
                        {TRANSFER_REASONS.map(r => (
                            <option key={r.value} value={r.value}>{r.label}</option>
                        ))}
                    </select>
                </div>
            </div>
        </NeoModal>
    );
};

export default PlatformTransferModal;
